import usePressKey from "./usePressKey";

function usePressEscapeKey(callback: Function) {
    return usePressKey("Escape", callback);
}

export default usePressEscapeKey;
